module.exports = {
    SUCCESS : {
        id : 0,
        reason : "The update was succesful"
    },
    INCOMPATIBLE_UPDATE : {
        id : 1,
        reason : "The update value was incompatible with the topic type"
    },
    UPDATE_FAILED : {
        id : 2,
        reason : "The update could not be applied"
    },
    INVALID_UPDATER : {
        id : 3,
        reason : "The updater was invalid for updating this topic"
    },
    MISSING_TOPIC : {
        id : 4,
        reason : "The specified topic does not exist"
    },
    INVALID_ADDRESS : {
        id : 5,
        reason : "The update for a Paged Topic contained an invalid index"
    },
    DUPLICATES : {
        id : 6,
        reason : "The update for a Paged Topic contained invalid duplicate items"
    },
    EXCLUSIVE_UPDATER_CONFLICT : {
        id : 7,
        reason : "An exclusive update source is already registered for the topic branch"
    },
    DELTA_WITHOUT_VALUE : {
        id : 8,
        reason : "A delta was applied to a topic that does not yet have a value"
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/update-topic/update-topic-response.js
// module id = 303
// module chunks = 1